import { Explotacion } from './../entities/explotacion.entity';
import { Contrato } from './../entities/contrato.entity';
import { Injectable, EventEmitter } from '@angular/core';
import { UsuarioOnline } from '../entities/UsuarioOnline.entity';
import { ContratosUser } from '../entities/ContratosUser.entity';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  public fecharefresco: Date;
  public login: string;
  public nombre: string;
  public email: string;
  public telefono: string;
  public telefono2: string;
  public efactura: boolean;
  public isAuthenicated = false;
  public sessionEvent: EventEmitter<any>;
  public sessionEvent2: EventEmitter<any>;
  public apiServer: string;
  public version: string;
  public explotacion: string;
  public contratos: Contrato[];
  public usuario: UsuarioOnline;
  public contratoSelected: Contrato;
  public PosicionContratoSelected: number;
  public datosExplotacion: Explotacion;
  public Explotaciones: Explotacion[];
  public isEmmasa: Boolean = false;
  public TPVPage: string;
  public permitirPagoOVE: boolean;
  public pendingChangePass = false;
  public isShowedENS = true;
  public esPagadorOInactivo = false;

  constructor() {
    this.sessionEvent = new EventEmitter();
    this.sessionEvent2 = new EventEmitter();
  }

  public authenicated(user: ContratosUser, explotaciones: Explotacion[]) {
    this.login = user.UsuarioOnline.Login;
    this.nombre = user.UsuarioOnline.Nombre;
    this.email = user.UsuarioOnline.EMail;
    this.telefono = user.UsuarioOnline.Telefono1;
    this.telefono2 = user.UsuarioOnline.Telefono2;
    this.efactura = user.UsuarioOnline.EFactura;
    this.explotacion = user.UsuarioOnline.Explotacion;
    this.isAuthenicated = true;
    this.usuario = user.UsuarioOnline;
    this.contratos = user.Contratos;
    this.Explotaciones = explotaciones;
    if (explotaciones !== undefined) {
      for (const explotacion of explotaciones) {
        if (explotacion.Codigo === this.explotacion) {
          this.datosExplotacion = explotacion;
        }
      }
      if (this.datosExplotacion !== undefined) {
        this.isEmmasa = this.datosExplotacion.Codigo === 'Emmasa';
        this.permitirPagoOVE = this.datosExplotacion.PermitirPagosOVE &&
          (this.datosExplotacion.CadenaPagoOVE === 'TODOS' || this.email.includes(this.datosExplotacion.CadenaPagoOVE));
      }
    }
    this.sessionEvent.emit(user);
    this.fecharefresco = new Date();
  }

  public updateEsPagador() {
    this.sessionEvent2.emit(this.esPagadorOInactivo);
  }

  public logout() {
    this.login = '';
    this.nombre = '';
    this.email = '';
    this.isAuthenicated = false;
    this.contratoSelected = undefined;
    this.datosExplotacion = undefined;
    this.Explotaciones = undefined;
    this.contratos = undefined;
    this.fecharefresco = undefined;
    if (typeof (Storage) !== 'undefined') {
      localStorage.setItem('Oficina.WebApi.Angular4.Token', '');
    }
  }
}
